import { CircularProgress, Box } from '@mui/material'
import React from 'react'

const CustomLoader = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                <CircularProgress size={60} thickness={4} />
            </Box>
        </Box>
    )
}


const Loader = () => {
    return (
        <div className="pageloaderWrp">
            <div className="pageLoadr custom_loader ">
                <CircularProgress />
            </div>
        </div>
    )
}

export default CustomLoader
export { Loader }